/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {MdLineModule, MdCommonModule} from '../core';
import {
  MdGridTile, MdGridTileText, MdGridTileFooterCssMatStyler,
  MdGridTileHeaderCssMatStyler, MdGridAvatarCssMatStyler
} from './grid-tile';
import {MdGridList} from './grid-list';
export class MdGridListModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [MdLineModule, MdCommonModule],
  exports: [
    MdGridList,
    MdGridTile,
    MdGridTileText,
    MdLineModule,
    MdCommonModule,
    MdGridTileHeaderCssMatStyler,
    MdGridTileFooterCssMatStyler,
    MdGridAvatarCssMatStyler
  ],
  declarations: [
    MdGridList,
    MdGridTile,
    MdGridTileText,
    MdGridTileHeaderCssMatStyler,
    MdGridTileFooterCssMatStyler,
    MdGridAvatarCssMatStyler
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdGridListModule_tsickle_Closure_declarations() {
/** @type {?} */
MdGridListModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdGridListModule.ctorParameters;
}



export {MdGridList} from './grid-list';
export {MdGridTile} from './grid-tile';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
